export const TRUST_ICON_KEYS = ['delivery', 'catalog', 'secure', 'support'];

const cleanText = (value) => {
  if (value === undefined || value === null) return '';
  const text = String(value).trim();
  if (!text || text === 'undefined' || text === 'null') return '';
  return text;
};

export const DEFAULT_CONTENT_BLOCKS = {
  hero: {
    fallbackEnabled: true,
    fallbackSlides: [
      { tag: '', title: '', subtitle: '' },
      { tag: '', title: '', subtitle: '' },
      { tag: '', title: '', subtitle: '' }
    ],
    benefitsEnabled: true,
    benefitsTitle: '',
    benefits: ['', '', '', '', '', ''],
    showContactEmail: true
  },
  trustBar: {
    enabled: true,
    items: TRUST_ICON_KEYS.map((icon) => ({ icon, title: '', description: '' }))
  },
  footerCta: {
    enabled: true,
    title: '',
    description: ''
  }
};

export const normalizeContentBlocks = (raw = {}) => {
  const hero = raw.hero && typeof raw.hero === 'object' ? raw.hero : {};
  const trustBar = raw.trustBar && typeof raw.trustBar === 'object' ? raw.trustBar : {};
  const footerCta = raw.footerCta && typeof raw.footerCta === 'object' ? raw.footerCta : {};

  const fallbackSlides = [0, 1, 2].map((index) => {
    const slide = Array.isArray(hero.fallbackSlides) ? hero.fallbackSlides[index] : {};
    return {
      tag: cleanText(slide?.tag),
      title: cleanText(slide?.title),
      subtitle: cleanText(slide?.subtitle)
    };
  });

  const benefits = [0, 1, 2, 3, 4, 5].map((index) => {
    const item = Array.isArray(hero.benefits) ? hero.benefits[index] : '';
    return cleanText(item);
  });

  const trustItems = [0, 1, 2, 3].map((index) => {
    const item = Array.isArray(trustBar.items) ? trustBar.items[index] : {};
    const icon = TRUST_ICON_KEYS.includes(item?.icon) ? item.icon : TRUST_ICON_KEYS[index];
    return {
      icon,
      title: cleanText(item?.title),
      description: cleanText(item?.description)
    };
  });

  return {
    hero: {
      fallbackEnabled: hero.fallbackEnabled !== false,
      fallbackSlides,
      benefitsEnabled: hero.benefitsEnabled !== false,
      benefitsTitle: cleanText(hero.benefitsTitle),
      benefits,
      showContactEmail: hero.showContactEmail !== false
    },
    trustBar: {
      enabled: trustBar.enabled !== false,
      items: trustItems
    },
    footerCta: {
      enabled: footerCta.enabled !== false,
      title: cleanText(footerCta.title),
      description: cleanText(footerCta.description)
    }
  };
};

const HERO_I18N_KEYS = [
  { tag: 'heroTag', title: 'heroTitle', subtitle: 'heroSubtitle' },
  { tag: 'heroTagAlt', title: 'heroTitleAlt', subtitle: 'heroSubtitleAlt' },
  { tag: 'heroTagThird', title: 'heroTitleThird', subtitle: 'heroSubtitleThird' }
];

export const resolveHeroFallbackSlides = (contentBlocks, t) => {
  if (contentBlocks?.hero?.fallbackEnabled === false) {
    return [];
  }
  const cmsSlides = contentBlocks?.hero?.fallbackSlides || [];
  return HERO_I18N_KEYS.map((keys, index) => {
    const cms = cmsSlides[index] || {};
    return {
      tag: cleanText(cms.tag) || t(`storefront.${keys.tag}`),
      title: cleanText(cms.title) || t(`storefront.${keys.title}`),
      subtitle: cleanText(cms.subtitle) || t(`storefront.${keys.subtitle}`)
    };
  });
};

export const resolveHeroBenefits = (contentBlocks, t) => {
  if (contentBlocks?.hero?.benefitsEnabled === false) {
    return {
      enabled: false,
      title: '',
      benefits: [],
      showContactEmail: false
    };
  }
  const cmsBenefits = contentBlocks?.hero?.benefits || [];
  const benefits = [0, 1, 2, 3, 4, 5].map((index) => {
    const cmsValue = cleanText(cmsBenefits[index]);
    return cmsValue || t(`storefront.heroBenefit${index + 1}`);
  });
  return {
    enabled: true,
    title: cleanText(contentBlocks?.hero?.benefitsTitle) || t('storefront.whyChooseUs'),
    benefits,
    showContactEmail: contentBlocks?.hero?.showContactEmail !== false
  };
};

export const resolveTrustBarItems = (contentBlocks, t) => {
  if (contentBlocks?.trustBar?.enabled === false) {
    return { enabled: false, items: [] };
  }
  const cmsItems = contentBlocks?.trustBar?.items || [];
  const items = TRUST_ICON_KEYS.map((key, index) => {
    const cms = cmsItems[index] || {};
    const titleRaw = cms.title;
    const descRaw = cms.description;
    const title = titleRaw === undefined || titleRaw === null ? '' : String(titleRaw).trim();
    const description = descRaw === undefined || descRaw === null ? '' : String(descRaw).trim();
    return {
      icon: key,
      title: title || t(`storefront.trust.${key}.title`),
      description: description || t(`storefront.trust.${key}.desc`)
    };
  });
  return { enabled: true, items };
};

export const resolveFooterCta = (contentBlocks, t) => {
  if (contentBlocks?.footerCta?.enabled === false) {
    return { enabled: false, title: '', description: '' };
  }
  return {
    enabled: true,
    title: contentBlocks?.footerCta?.title || t('storefront.footer.ctaTitle'),
    description: contentBlocks?.footerCta?.description || t('storefront.footer.ctaDesc')
  };
};
